//#region Email Body

import { BrandFeatureName, FeatureName } from '../features';

//#region Email Body

//#region Data Type
export interface EmailGeneralData {
  confId: string;
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  warnColor: string;
  featuresInsurer: {
    [key in FeatureName]?: boolean;
  };
  featuresBrand?: {
    [key in BrandFeatureName]?: boolean;
  };
  coLogo?: string;
}

export interface EmailData extends EmailCtaData {
  subject: string;
}

export interface EmailCtaData {
  accesslink?: string;
  linkFitterModifyApmt?: string;
  linkUpload?: string;
  linkCallFitter?: string;
  linkCalendar?: string;
  linkModifyApmt?: string;
  linkCancelApmt?: string;
  googleMapLink?: string;
}

export interface CustomerData {
  customerName: string;
  customerAddress: string;
  customerPhone?: string;
}

export interface SinisterData {
  carDescription: string;
  licensePlate: string;
  operation: string;
  operationGendered?: string;
  operationGenderedForCustomer?: string;
}

export interface ExcessData {
  excess: string;
}

export interface FitterData {
  fitterName: string;
  fitterCity: string;
  fitterAddress: string;
  fitterPostalCode: string;
  fitterPhone: string;
}

export interface AppointmentData {
  appointmentDayLabel: string;
  appointmentMonthLabel: string;
  appointmentDay: string;
  appointmentMonth: string;
  appointmentYear: string;
  appointmentHour: string;
  appointmentMinutes: string;
  outsideIntervention: boolean;
  appointmentAmOrPm: string;
  appointmentHalfDay: string;
}

export interface AppointmentLocalizedData {
  apmtFullDateTime: string;
  apmtDateTime: string;
  apmtFullDate: string;
  apmtShortDate: string;
  apmtFullTime: string;
}

export interface PreviousAppointmentData {
  previousAppointmentDayLabel: string;
  previousAppointmentMonthLabel: string;
  previousAppointmentDay: string;
  previousAppointmentHour: string;
  previousAppointmentMinutes: string;
  outsideIntervention: boolean;
  previousAppointmentHalfDay: string;
}

export interface PreviousAppointmentLocalizedData {
  previousApmtFullDateTime: string;
  previousApmtDateTime: string;
  previousApmtFullDate: string;
  previousApmtShortDate: string;
  previousApmtFullTime: string;
}

export interface PhotoData {
  displayThreeQuarterPhoto: boolean;
  displayCloserLookPhoto: boolean;
  displayInsuranceCardPhoto: boolean;
  displayVehicleRegistrationPhoto: boolean;
  displayDrivingLicensePhoto: boolean;
  displayCorrectPhotoTitle: boolean;
  displayErrorPhotoTitle: boolean;
  allDocumentsError: boolean;
}

export interface AppointmentSuggestionData {
  date: AppointmentData;
  replacementVehicle: boolean;
}

export interface ReplacementVehicleData {
  suggestionsDate1: string;
  suggestionsDate2: string;
  suggestionsDate3: string;
  replacementVehicle1: boolean;
  replacementVehicle2: boolean;
  replacementVehicle3: boolean;
}

//#endregion Data Type
